<template>
  <main class="campaign-creator">
    <div class="editor-container">
      <editor
        :value="editorValue"
        @update:value="updatedEditor"
        @blur="blurredEditor"
        ref="editor"
        :class="{ 'invalid-text':invalidText }"
      />

      <campaign-action-bar
        @shouldInsertText="shouldInsertText"
        :class="{ 'invalid-text':invalidText }"
      />
    </div>

    <campaign-extensions v-if="!classicCampaignsEnabled"/>
  </main>
</template>

<script>
import Editor from "./editor";
import CampaignActionBar from "./action-bar/campaign-action-bar";
import CampaignExtensions from "./extensions/campaign-extensions";
import {mapGetters} from "vuex";
import {campaignAPI} from "../../services/api/campaignAPI";

export default {
  name: "campaign-creator",
  components: {CampaignExtensions, CampaignActionBar, Editor},

  data() {
    return {
      editorValue: '',
    };
  },

  methods: {
    shouldInsertText(text) {
      this.$refs.editor.insertText(text);
    },
    async updatedEditor(text) {
      this.$store.commit('VALIDATE_FIELD', { field: 'sms_content', value: text })
      const resp = await campaignAPI.updateMessage(this.campaign.id, text);
      this.editorValue = resp.sms_text;
    },
    blurredEditor() {
      this.$store.commit('TOUCHED_FIELD', 'sms_content');
    }
  },

  computed: {
    campaign() {
      const campaign = this.$store.getters.campaign;
      this.editorValue = campaign.sms_content || this.editorValue;
      return campaign;
    },
    invalidText() { return this.$store.getters.hasError('sms_content'); },
    ...mapGetters(['classicCampaignsEnabled']),
  }
}
</script>

<style scoped>
.campaign-creator {
  display:flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.editor-container {
  display:flex;
  flex-direction: column;
  width: 61%;
}

.invalid-text {
  border-color: #f91253;
}
</style>
